import Styled from "styled-components";

export const CenteredLogoImg = Styled.div`
   & > img {
     position: absolute;
     left: 3rem;
     width:180px;
     height:46px;
   } 

  & > span {
    font-weight:bold !important;
  }
`;
